import { useSelector } from 'react-redux';
import { State } from '~/Store';

export function useShowAllProducts(): boolean {
	return useSelector<State, boolean>((state) => state.products.showAllProducts);
}
